(function () {
        change();
    
        function change() {
            if (document.documentElement.clientWidth > 768) {
                document.documentElement.style.fontSize = document.documentElement.clientWidth * 20 / 1920 + 'px';
            } else {
                document.documentElement.style.fontSize = document.documentElement.clientWidth * 20 / 749 + 'px';
            }
        }
        /* 监听窗口大小发生改变时 */
        window.addEventListener('resize', change, false);
    })();

